import { LandingFeature } from '../features/home/landing-feature';

export default function HomePage() {
  return <LandingFeature />;
}
